<script lang="ts" setup>
const emit = defineEmits(["continue", "close"]);
const userStore = useUserStore();
const route = useRoute();
const localePath = useLocalePath();

const doLogout = () => {
  userStore.logOut();
  if (route.path.includes("user-portal")) navigateTo(localePath("/"));
  emit("close");
};
</script>

<template>
  <div class="flex flex-col items-center gap-4 max-w-md mx-auto my-4">
    <BaseIcon name="GFAL_warning" class="w-20 h-20 my-4" />
    <h3 class="text-neutral-200 text-2xl font-bold">
      {{ $t("main.walletLock.walletLocked") }}
    </h3>
    <p class="text-neutral-300 max-w-sm text-center">
      {{ $t("main.walletLock.securityNoticeBody") }}
    </p>
    <BaseButtonSubmit
      :text="$t('main.modalUserWalletCreate.continue')"
      @click="emit('continue')"
      class="w-64" />
    <BaseButtonCancel
      type="button"
      :text="$t('main.modalIdleUser.signOutButton')"
      data-test="button-sign-out-from-idle-expired"
      @click="doLogout"
      class="w-64" />
  </div>
</template>
